import { ComponentProps, Dispatch, SetStateAction, useCallback } from 'react';

import Flag, { FlagGroup as AkFlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { token } from '@atlaskit/tokens';

export type FlagGroupItem = {
  hasError?: boolean;
} & Pick<ComponentProps<typeof Flag>, 'id' | 'description' | 'title'>;

const FlagGroup = ({
  setFlags,
  flags,
}: {
  setFlags: Dispatch<SetStateAction<FlagGroupItem[]>>;
  flags: FlagGroupItem[];
}): JSX.Element => {
  const dismissFlag = useCallback(
    (id: string | number) => {
      setFlags(current => current.filter(flag => flag.id !== id));
    },
    [setFlags]
  );

  return (
    <AkFlagGroup onDismissed={dismissFlag}>
      {flags.map(flag => {
        return (
          <Flag
            id={flag.id}
            icon={
              flag.hasError ? (
                <ErrorIcon
                  primaryColor={token('color.icon.danger')}
                  label=""
                  size="medium"
                />
              ) : (
                <SuccessIcon
                  primaryColor={token('color.icon.success')}
                  label=""
                  size="medium"
                />
              )
            }
            key={flag.id}
            title={flag.title}
            description={flag.description}
          />
        );
      })}
    </AkFlagGroup>
  );
};

export default FlagGroup;
